// extracted by mini-css-extract-plugin
export var card = "MiniCard-module--card--fab18";
export var cdsAssistiveText = "MiniCard-module--cds--assistive-text--4aa49";
export var cdsVisuallyHidden = "MiniCard-module--cds--visually-hidden--f3718";
export var hideFeedback = "MiniCard-module--hide-feedback--fc4de";
export var icon = "MiniCard-module--icon--aeee9";
export var image = "MiniCard-module--image--3fb49";
export var showFeedback = "MiniCard-module--show-feedback--120be";
export var skeleton = "MiniCard-module--skeleton--145cf";
export var title = "MiniCard-module--title--bfa0c";
export var wrapper = "MiniCard-module--wrapper--77e2e";